import { useContext } from 'react'
import type { Layout } from '../contexts/LayoutContext'
import LayerContext from '../contexts/LayoutContext'

const useLayout = (): Layout => useContext(LayerContext)

export default useLayout
